<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div v-bind:key="item.SReturnId" v-for="item in printList">
                <div class="print-title">销售退货单</div>
                <div class="order-detail">
                    <div>退货单号：{{ item.ReturnCode }}</div>
                    <div>
                        退货日期：
                        <el-date-picker
                            v-show="isEditOpenTime"
                            v-model="item.ReturnTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            size="small"
                            placeholder="选择日期时间"
                        ></el-date-picker>
                        <span v-show="!isEditOpenTime">{{ item.ReturnTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp;客户名称</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.EntpCusName }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp;客户地址</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.FullAddress }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">汽配编码</div>
                        <div class="div-table-cell" style="width: 25%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 11%">数量</div>
                        <div class="div-table-cell" style="width: 11%">单位</div>
                        <div class="div-table-cell" style="width: 13%">退单价</div>
                    </div>
                    <div class="div-table-row" v-bind:key="AP.index" v-for="AP in item.DetailList">
                        <div class="div-table-cell" style="width: 20%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 25%">
                            {{ AP.GoodName }}
                        </div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 11%">
                            {{ AP.ReturnCount }}
                        </div>
                        <div class="div-table-cell" style="width: 11%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 13%">
                            {{ AP.ReturnPrice }}
                        </div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 25%"></div>
                        <div class="div-table-cell pall-count" style="width: 20%">总数量：</div>
                        <div class="div-table-cell" style="width: 11%">{{ item.TotalCount }}</div>
                        <div class="div-table-cell pall-count" style="width: 11%">总价：</div>
                        <div class="div-table-cell" style="width: 13%">{{ item.TotalRetrunAmount }}</div>
                    </div>
                </div>
                <div class="order-detail">
                    <div>退款方式：{{ item.PayTypeName }}</div>
                    <div>退款金额：{{ item.Paid }}</div>
                </div>
                <div class="order-remark">
                    <div>退货原因：{{ item.Reasons }}</div>
                </div>
                <!--    脚注    -->
                <div
                    class="order-remark"
                    v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet"
                    v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                >
               
                </div>
                <div class="order-setcontent" v-if="isEditConfig">
                    <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig&& !orderData.IsHaveTitleSet">备注</el-button>
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存备注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            permission: {},

            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间

            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            entpId: userMsg.EntpId,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData: {},
        };
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.printList = [];
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz', 'dyxsthsj', 'dyxsth'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyxsthsj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxsth':
                                    this.config = data[i];
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<head><meta charset="utf-8" /><style>
                    .order-detail {
                    width: 742px;
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-left: 10px;
                    margin-right: 10px;
                    padding: 15px 0;
                    color: #000;
                    }
                    .order-remark {
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-left: 10px;
                    margin-right: 10px;
                    padding: 0px 0px 15px 0px;
                    color: #000;
                    }
                    .order-setcontent {
                    padding: 0px 0px 15px 0px;
                    color: #000;
                    }
                    .print-title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    color: #000;
                    }
                    .dialog-footer {
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 20px;
                    }
                    .re-submit {
                    text-align: right;
                    }

                    .print-zone {
                    width: 200mm;
                    margin-left: 2rpx;
                    }

                    .print-table-main {
                    width: 762px;
                    margin-left: 1px;
                    font-size: 12px;
                    }
                    .pall-count {
                        text-align: right;
                    }
                    .div-table-cell {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: auto;
                        line-height: 30px;
                        padding-left: 10px;
                        border-top: 1px solid #000;
                        border-right: 1px solid #000;
                        border-bottom: 1px solid #000;
                        color: #000;
                    }
                    .btn-ctn-left {
                    display: flex;
                    }
                    .div-table-row {
                        display: flex;
                        border-left: 1px solid #000;
                        margin: 0;
                        font-size: 14px;
                    }
                    </style></head>`;

                let strPrintHtml = '<!DOCTYPE html><html>' + strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body></html>';
                let contentHeight = document.getElementById('printContent').clientHeight;
                if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }

                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 9 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetOrderDetailForPrint',
                    data: {
                        SReturnId: this.printIds[0]
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = res.data;
                    this.printList.push(res.data);
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入备注');
                return;
            }
            this.loading = true;
            this.isEditConfig = false;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/UpdateSysConfigResultsById',
                    data: {
                        EntpId: this.entpId,
                        ConfigId: this.config.ConfigId,
                        RValue: this.config.RValue
                    },
                    hideLoading: true
                })
                .then(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped media="print">
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
</style>
